// src/context/ToastProvider.js
import React, {
  createContext,
  useState,
  useCallback,
  useContext,
  useEffect,
} from "react";
import SystemMessage from "../customComp/SystemMessage";

const ToastContext = createContext();

// Add global reference
let toastRef = null;

export const setToastRef = (ref) => {
  toastRef = ref;
};

export const globalToast = {
  add: (toast) => toastRef?.(toast),
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((toast) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { ...toast, id }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  useEffect(() => {
    setToastRef(addToast); 
  }, [addToast]);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="fixed top-5 left-1/2 transform -translate-x-1/2 flex flex-col gap-4 z-[9999]">
        {toasts.map(({ id, ...toast }) => (
          <SystemMessage
            key={id}
            {...toast}
            handleClose={() => removeToast(id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
